









































































































































































































































// @ts-nocheck
import { ScheduleComponent, Day, Week, Month, DragAndDrop, ExcelExport, Print } from '@syncfusion/ej2-vue-schedule';
import { AccordionComponent } from '@syncfusion/ej2-vue-navigations';
import * as api from '@/scripts/services/api'
import MaintenancePlanDialog from './MaintenancePlanDialog.vue'
import { MultiSelectComponent } from '@syncfusion/ej2-vue-dropdowns'
import MaintenancePlanMultiUpdate from './MaintenancePlanMultiUpdate.vue'
import WorkOrderStatusLegend from '../partials/WorkOrderStatusLegend.vue'
import * as workOrderStatusPolicy from '@/scripts/services/workOrderStatusPolicy'
import { OtherApi } from '@/scripts/services/OtherApis'
import * as swal from '@/helpers/swal'
import * as dateFormat from '../../helpers/dateFormat';
import { confirmFreezes, fetchFreezes, formatFreezePeriod } from '@/helpers/freeze';
import ExcelJS from 'exceljs';

const scheduledMs = (data: any) => new Date(data.ScheduledTime).getTime()

const MINUTE_MS = 60000

// Freeze araliklari yari acik: [StartDate, EndDate).
const overlaps = (freeze: any, startMs: number, endMs: number) =>
  freeze.start.getTime() < endMs && startMs < freeze.end.getTime()

export default {
  components: {
    'ejs-schedule': ScheduleComponent,
    'maintenance-plan-dialog': MaintenancePlanDialog,
    'ejs-multiselect': MultiSelectComponent,
    'maintenance-plan-multi-update': MaintenancePlanMultiUpdate,
    'ejs-accordion': AccordionComponent,
    'work-order-status-legend': WorkOrderStatusLegend,
  },
  props: {
    defaultStartDate: {
      type: String,
      default: undefined
    },
    defaultEndDate: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      filterNameForSave: "",
      savedFilters: [],
      apiClient: new OtherApi<any>(),
      isDialogActive: false,
      isMultiUpdateDialogActive: false,
      createStartDate: null,
      selectedId: 0,
      onlyAssigneeEditable: false,
      // Suruklemenin basladigi andaki planlanan saat; tarih gercekten degisti mi diye bakilir.
      dragStartScheduledTime: null,
      // Gorunen araliga denk gelen freeze donemleri: { start, end, tooltip, view }. view sunucudan
      // gelen ham kayit; onay penceresi (confirmFreezes) onu bekliyor.
      freezes: [],
      // freezes listesinin hangi aralik icin alindigi. Bu aralik disina dusen bir pencere icin
      // listeye guvenilmez, sunucuya sorulur. Liste alinamadiysa null.
      freezeRange: null,
      // Hizli gezinmede gec donen eski cevap yenisini ezmesin diye.
      freezeRequestNo: 0,
      selectedMaintenancePlan: [],
      loading: false,
      timeFormat: 'HH:mm',
      startDate: new Date(),
      endDate: new Date(),
      defaultDate: new Date(),
      searchText: '',
      workOrderStatuses: [],
      selectedWorkOrderStatuses: [],
      userList: [],
      selectedUserList: [],
      deleteBtnShow: false,
      eventSettings: {
        dataSource: [
          // {
          //     Id: 1,
          //     FullName: 'Meeting',
          //     ScheduledTime: new Date().toISOString(),
          //     ExpectedEndTime: new Date(new Date().setHours(new Date().getHours()+1)).toISOString(),
          // }
        ],
        fields: {
          id: 'Id',
          subject: { name: 'FullName' },
          startTime: { name: 'ScheduledTime' },
          endTime: { name: 'ExpectedEndTime' },
          location: {name: 'DeviceName'}
        },
      },
      views: ['Day', 'Week', 'Month'],
      currentView: 'Month',
      timezone: 'Europe/Istanbul',
      firstDayOfWeek: 1,
      translations: {
        search: "Search",
        status: "Status",
        user: "User",
        select: "Select",
        deselect: "Deselect",
        selected: "Selected",
        filter: "Filter",
        filterSave: "Filter Save",
        savedFilters: "Saved Filters",
        filterName: "Filter Name",
        save: "Save",
        apply: "Apply",
        delete: "Delete"
      },
      scheduleTranslations: {
        Monday: 'Pazartesi',
        Tuesday: 'Salı',
        Wednesday: 'Çarşamba',
        Thursday: 'Perşembe',
        Friday: 'Cuma',
        Saturday: 'Cumartesi',
        Sunday: 'Pazar',
        Jan: 'Oca',
        Feb: 'Şub',
        Mar: 'Mar',
        Apr: 'Nis',
        Jun: 'Haz',
        Jul: 'Tem',
        Aug: 'Ağu',
        Sep: 'Eyl',
        Oct: 'Eki',
        Nov: 'Kas',
        Dec: 'Ara',
        Mon: 'Pzt',
        Tue: 'Sal',
        Wed: 'Çar',
        Thu: 'Per',
        Fri: 'Cum',
        Sat: 'Cmt',
        Sun: 'Paz',
        January: 'Ocak',
        February: 'Şubat',
        March: 'Mart',
        April: 'Nisan',
        June: 'Haziran',
        July: 'Temmuz',
        August: 'Ağustos',
        September: 'Eylül',
        October: 'Ekim',
        November: 'Kasım',
        December: 'Aralık',
        Today: 'Bugün',
        Day: 'Gün',
        Week: 'Hafta',
        MONTH: 'Ay',
        Year: 'Yıl',
        'All day': 'Tüm gün',
        Save: 'Kaydet',
        Cancel: 'İptal',
        Delete: 'Sil',
        Edit: 'Düzenle',
        Event: 'Etkinlik',
        'No events': 'Etkinlik yok',
        'Event Details': 'Etkinlik Detayları',
        'Add Event': 'Etkinlik Ekle',
      },
    }
  },
  provide: {
    schedule: [Day, Week, Month, DragAndDrop, ExcelExport, Print],
  },
  computed: {
    // Efsanede yalnizca takvimde o an bulunan statuler gosterilir; kullanilmayan renkleri
    // basmak satiri gereksiz uzatiyor. Renkler de statuden geliyor (kayitlardaki ColorCode).
    legendStatusIds() {
      //@ts-ignore
      return [...new Set((this.eventSettings.dataSource || []).map((e: any) => e.StatusId).filter(Boolean))]
    },
  },
  watch: {
    'eventSettings.dataSource': {
      handler(newVal: any, oldVal: any) {},
      deep: true,
    },
  },

  mounted() {
    if(this.$route.query.defaultStartDate && this.$route.query.defaultEndDate){
      this.currentView = "Day";
      this.defaultDate = new Date(Number(this.$route.query.defaultStartDate));
      this.startDate = new Date(Number(this.$route.query.defaultStartDate));
      this.endDate = new Date(Number(this.$route.query.defaultEndDate));
    }else {
      const schedule = this.$refs.ScheduleObj.ej2Instances;
      const visibleDates = schedule.getCurrentViewDates();
      this.startDate = new Date(visibleDates[0].getTime()) ;
      this.endDate = new Date(visibleDates[visibleDates.length - 1].getTime() + 86400000);
    }
    this.getSavedFilters();
    //@ts-ignore
    this.getData()
    this.loadFreezes()
    //@ts-ignore
    this.getWorkOrderStatuses()
    //@ts-ignore
    this.getUserList()
    this.translateScheduleTexts() // İlk çeviri işlemi
    // MutationObserver ile DOM değişikliklerini izleyin
    const observer = new MutationObserver(() => {
      clearTimeout(this.translationTimeout) // Eğer daha önce başlatılmış bir timeout varsa temizle
      this.translationTimeout = setTimeout(() => {
        this.translateScheduleTexts() // Gecikmeli çeviri işlemi
      }, 500) // 500ms gecikme
    })

    observer.observe(document.body, { childList: true, subtree: true }) // Tüm sayfayı izleyin
    this.observer = observer // observer'ı kaydediyoruz ki bileşen yok edilmeden önce durdurabilelim
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect() // Bileşen yok edilmeden önce gözlemlemeyi durdur
    }
    if (this.translationTimeout) {
      clearTimeout(this.translationTimeout) // Timeout'u temizle
    }
  },
  methods: {
    async filterSave() {
      if(this.filterNameForSave === ""){
        if(localStorage.getItem("vue-lang") === "tr-TR"){
          swal.error("Filtreye bir isim veriniz")
        }else {
          swal.error("Give a name to the filter")
        }
        return;
      }
      let filterData = {
        filterName: this.filterNameForSave,
        searchText: this.searchText.trim(),
        selectedWorkOrderStatuses: this.selectedWorkOrderStatuses,
        selectedUserList: this.selectedUserList
      }
      let response = (await api.preventiveMaintenanceScheduleSaveFilter({FilterText:JSON.stringify(filterData)})).body;
      if(response.IsSuccess){
        this.filterNameForSave = "";
        if(localStorage.getItem("vue-lang") === "tr-TR"){
          swal.success("Kaydedildi","Filtre başarılı bir şekilde kaydedildi");
        }else{
          swal.success("Saved","Filter saved successfully");
        }
        this.getSavedFilters();
      }else{
        swal.error("Error")
      }
    },
    async getSavedFilters(){
      let response = (await api.preventiveMaintenanceScheduleGetFilters()).body;
      this.savedFilters = response;
    },
    filterUse(filter:any){
      let parsedFilter = JSON.parse(filter.FilterText);
      this.searchText = parsedFilter.searchText.trim();
      this.selectedWorkOrderStatuses = parsedFilter.selectedWorkOrderStatuses;
      this.selectedUserList = parsedFilter.selectedUserList;
      //@ts-ignore
      this.getData()
    },
    async filterDelete(filter:any){
      let response = (await api.preventiveMaintenanceScheduleDeleteFilter(filter.Id)).body;
      if(response.IsSuccess){
        this.getSavedFilters();
        if(localStorage.getItem("vue-lang") === "tr-TR"){
          swal.success("Filtre Silindi")
        }else{
          swal.success("Filter Deleted")
        }
      }else{
        swal.error("Error")
      }
    },
    // Eskiden adi translate idi ve global ceviri mixin'inin translate(key) metodunu golgeliyordu;
    // bu bilesende this.translate('...') bos donuyordu (freeze onay penceresi de onu kullaniyor).
    translateScheduleTexts() {
      if(localStorage.getItem("vue-lang") === "tr-TR"){
        // scheduleTranslations nesnesindeki yalnızca ay isimleri için işlem yap
        Object.entries(this.scheduleTranslations).forEach(([key, value]) => {
          // İngilizce ay ismini içeren span veya button öğelerini bul
          const xpath = `//span[contains(text(),'${key}')] | //button[contains(text(),'${key}')] | //div[contains(text(),'${key}')]`
          const elements = document.evaluate(xpath, document, null, XPathResult.ORDERED_NODE_SNAPSHOT_TYPE, null)

          // Bulunan her öğede metnin sadece ay ismini çevir
          for (let i = 0; i < elements.snapshotLength; i++) {
            const element = elements.snapshotItem(i) as HTMLElement
            if (element) {
              // Ay ismini koruyarak yılı değiştirme
              element.innerText = element.innerText.replace(new RegExp(`\\b${key}\\b`, 'gi'), value)
            }
          }
        })
        this.translations.search = "Ara";
        this.translations.status = "Durum";
        this.translations.user = "Kullanıcı Seç";
        this.translations.select = "Seç";
        this.translations.selected = "Seçildi";
        this.translations.deselect = "Seçimi Kaldır";
        this.translations.filter = "Filtre";
        this.translations.filterSave = "Filtre Kayıt";
        this.translations.savedFilters = "Kayıtlı Filtreler";
        this.translations.filterName = "Filte Adı";
        this.translations.save = "Kaydet";
        this.translations.apply = "Uygula";
        this.translations.delete = "Sil";
      }
    },

    getElementByXpath(path: string) {
      return document.evaluate(path, document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue
    },
    async getData() {
      //@ts-ignore
      this.loading = true
      let now = new Date()
      let response = (
        await api.GetPreventiveMaintenanceSchedules({
          //@ts-ignore
          StartDate: this.startDate.toISOString(),
          //@ts-ignore
          EndDate: this.endDate.toISOString(),
          //@ts-ignore
          SearchText: this.searchText ? this.searchText.trim() : null,
          //@ts-ignore
          Statuses: this.selectedWorkOrderStatuses ? this.selectedWorkOrderStatuses.map((item) => item.Value) : null,
          //@ts-ignore
          Personals: this.selectedUserList ? this.selectedUserList.map((item) => item.NameSurname) : null,
        })
      ).body
      //@ts-ignore
      this.eventSettings.dataSource = response
      //@ts-ignore
      this.eventSettings = { ...this.eventSettings } // UI'nin yeniden render edilmesi için
      //@ts-ignore
      this.loading = false
    },
    onCellClick: function (args: any) {
      args.cancel = true
    },
    onCellDoubleClick: async function (args: any) {
      args.cancel = true
      //@ts-ignore
      this.onlyAssigneeEditable = false
      //@ts-ignore
      this.deleteBtnShow = false;
      //@ts-ignore
      this.createStartDate = args.startTime
      //@ts-ignore
      this.selectedId = 0
      //@ts-ignore
      this.isDialogActive = true
      //@ts-ignore
      await this.$nextTick()
      //@ts-ignore
      ;(<MaintenancePlanDialog>this.$refs.maintenancePlanDialog).showDialog()
    },
    popupOpen: async function (args: any) {
      if (args.type === 'QuickInfo' && args.data) {
        args.cancel = true
      }
      if (args.type === 'Editor' && args.data) {
        args.cancel = true
        // Beklemede'de plan duzenlenemez ama personeli degistirilebilir: dialog yalnizca
        // personel alanlari acik halde acilir, plan alanlari kilitli gelir.
        //@ts-ignore
        this.onlyAssigneeEditable = workOrderStatusPolicy.isOnHold(args.data.StatusId)
        //@ts-ignore
        if (workOrderStatusPolicy.canEditPlanFields(args.data.StatusId) || this.onlyAssigneeEditable) {
          // //@ts-ignore
          // this.selectedMaintenancePlan = [args.data]
          // //@ts-ignore
          // this.createStartDate = null
          // //@ts-ignore
          // this.isMultiUpdateDialogActive = true
          // //@ts-ignore
          // await this.$nextTick()
          // //@ts-ignore
          // ;(<MaintenancePlanMultiUpdate>this.$refs.maintenancePlanMultiUpdate).showDialog()
          //@ts-ignore
          this.selectedId = args.data.Id
          //@ts-ignore
          this.deleteBtnShow = !this.onlyAssigneeEditable;
          //@ts-ignore
          this.createStartDate = null
          //@ts-ignore
          this.isDialogActive = true
          //@ts-ignore
          await this.$nextTick()
          //@ts-ignore
          ;(<MaintenancePlanDialog>this.$refs.maintenancePlanDialog).showDialog()
        } else {
          args.cancel = true;
          if(localStorage.getItem("vue-lang") === "tr-TR"){
            swal.error("Error","Planlandı ve Atama Yapıldı statüsü harici düzenleme yapılamaz.")
          }else{
            swal.error("Error","No edits can be made except for the Planned and Assigned status.")
          }
        }
      }
    },
    onNavigating: function (args: any) {
      this.handleNavigate(args)
    },
    async handleNavigate(args: any){
      await this.$nextTick();
      if (args.action === 'date' || args.action === "view") {
        const schedule = this.$refs.ScheduleObj.ej2Instances;
        const visibleDates = schedule.getCurrentViewDates();
        this.startDate = new Date(visibleDates[0].getTime()) ;
        this.endDate = new Date(visibleDates[visibleDates.length - 1].getTime() + 86400000);
        this.getData()
        this.loadFreezes()
      }
    },
    scheduleInstance() {
      return this.$refs.ScheduleObj ? this.$refs.ScheduleObj.ej2Instances : null
    },
    // Sunucu tarihleri duvar saati olarak bekliyor ve oyle donduruyor (bkz. dateFormat.parseWallClock).
    // Cevap alinamazsa null: cagiran "bilinmiyor" ile "freeze yok"u ayirabilsin.
    requestFreezes(start: Date, end: Date) {
      return fetchFreezes(this.$globalApiClient.freeze.freezeGetInRange({
        startDate: dateFormat.postDateTimeFormatFromDateObject(start),
        endDate: dateFormat.postDateTimeFormatFromDateObject(end),
      }))
    },
    async loadFreezes() {
      const requestNo = ++this.freezeRequestNo
      // startDate/endDate yerinde degistirilmiyor, yalnizca yeniden ataniyor; kopyalamaya gerek yok.
      const start = this.startDate
      const end = this.endDate
      const views = await this.requestFreezes(start, end)
      if (requestNo !== this.freezeRequestNo) {
        return
      }
      this.freezes = (views || [])
        .map((view: any) => {
          const freezeStart = dateFormat.parseWallClock(view.StartDate)
          const freezeEnd = dateFormat.parseWallClock(view.EndDate)
          return {
            start: freezeStart,
            end: freezeEnd,
            // Her cizimde her hucre icin yeniden bicimlenmesin diye bir kez hesaplanir.
            tooltip: freezeStart && freezeEnd
              ? `${this.translate('freeze_period')}: ${formatFreezePeriod(freezeStart, freezeEnd, view.Description)}`
              : '',
            view,
          }
        })
        .filter((freeze: any) => freeze.start && freeze.end)
      this.freezeRange = views ? { start, end } : null
      // renderCell yalnizca Syncfusion hucreyi cizerken calisiyor; liste geldiginde ekrandaki
      // hucreler zaten cizilmis oluyor. Takvimi yeniden cizdirmek yerine (gorunum/tarih ve
      // kaydirma korunsun, navigating tetiklenip yukleme dongusune girilmesin) mevcut hucreler
      // burada isaretlenir. Sonraki cizimleri renderCell ayni listeyle isaretler.
      this.decorateFreezeCells()
    },
    // Gun/hafta gorunumunde bir hucre bir zaman dilimi; uzunlugu timeScale'den (varsayilan 60/2).
    slotMinutes() {
      const schedule = this.scheduleInstance()
      const timeScale = schedule && schedule.timeScale
      return timeScale && timeScale.interval > 0 && timeScale.slotCount > 0 ? timeScale.interval / timeScale.slotCount : 30
    },
    // Hucreyi o anki listeye gore isaretler ya da isaretini kaldirir; ayni hucrede tekrar
    // cagrilmasi zararsiz (renderCell ve decorateFreezeCells ayni hucreye denk gelebilir).
    // slotMinutes null ise hucre bir gunun tamamidir (ay ve tum gun hucreleri).
    markFreezeCell(cell: HTMLElement, cellStart: Date, slotMinutes: number | null, withBadge: boolean) {
      const cellEnd = slotMinutes === null
        ? new Date(cellStart.getFullYear(), cellStart.getMonth(), cellStart.getDate() + 1)
        : new Date(cellStart.getTime() + slotMinutes * MINUTE_MS)
      const hits = this.freezes.filter((freeze: any) => overlaps(freeze, cellStart.getTime(), cellEnd.getTime()))
      const badge = cell.querySelector('.schedule-freeze-badge')

      if (!hits.length) {
        if (cell.classList.contains('schedule-freeze-cell')) {
          cell.classList.remove('schedule-freeze-cell')
          cell.removeAttribute('title')
        }
        if (badge) {
          badge.parentNode.removeChild(badge)
        }
        return
      }

      cell.classList.add('schedule-freeze-cell')
      cell.setAttribute('title', hits.map((freeze: any) => freeze.tooltip).join('\n'))
      if (withBadge && !badge) {
        // Tarih basliginin (div.e-date-header) icine konmaz: translateScheduleTexts ay adi gecen
        // div'lerin innerText'ini yeniden yaziyor ve icindeki etiketi silerdi. "Freeze" metni o
        // sozlukteki hicbir kelimeyi icermedigi icin ceviri bu span'e dokunmaz.
        const element = document.createElement('span')
        element.className = 'schedule-freeze-badge'
        element.textContent = 'Freeze'
        cell.insertBefore(element, cell.firstChild)
      }
    },
    onRenderCell(args: any) {
      // Yeni cizilen hucrede kaldirilacak isaret olmaz; liste bossa ugrasmaya gerek yok.
      if (!args.date || !this.freezes.length) {
        return
      }
      if (args.elementType === 'monthCells') {
        this.markFreezeCell(args.element, args.date, null, true)
      } else if (args.elementType === 'alldayCells') {
        this.markFreezeCell(args.element, args.date, null, false)
      } else if (args.elementType === 'workCells') {
        this.markFreezeCell(args.element, args.date, this.slotMinutes(), false)
      }
    },
    decorateFreezeCells() {
      const schedule = this.scheduleInstance()
      if (!schedule || !schedule.element) {
        return
      }
      const isMonth = schedule.currentView === 'Month'
      const slotMinutes = isMonth ? null : this.slotMinutes()
      // data-date: hucrenin baslangici (ms). Sol girintideki "tum gun" hucresinde yok, o atlanir.
      const cells = schedule.element.querySelectorAll('.e-work-cells[data-date], .e-all-day-cells[data-date]')
      for (let i = 0; i < cells.length; i++) {
        const cell = cells[i]
        const isAllDay = cell.classList.contains('e-all-day-cells')
        const cellStart = new Date(Number(cell.getAttribute('data-date')))
        this.markFreezeCell(cell, cellStart, isAllDay ? null : slotMinutes, isMonth && !isAllDay)
      }
    },
    onEventRender(args: any) {
      const event = args.data // Etkinlik verisi
      if (event.ColorCode) {
        // Etkinlikte ColorCode varsa, etkinliğin stilini değiştiriyoruz
        args.element.style.backgroundColor = event.ColorCode
      }
      //@ts-ignore
    },
    handleSearchClick() {
      //@ts-ignore
      this.getData()
    },
    async getWorkOrderStatuses() {
      let response = (await api.getWorkOrderStatuses(1)).body
      //@ts-ignore
      this.workOrderStatuses = response
    },
    async getUserList() {
      let response = (await api.getUserListWithoutIncludes()).body
      //@ts-ignore
      this.userList = response
    },
    onDragStart(args: any) {
      //@ts-ignore
      this.dragStartScheduledTime = scheduledMs(args.data)
    },
    async onDragStop(args: any) {
      // Syncfusion yerinde yapilan bir tiklamayi da "surukleme bitti" sayiyor. Tarih
      // degismediyse sunucuya gitmiyoruz; yoksa salt tiklama "Kayit Guncellendi" popup'i
      // (uygun olmayan statulerde de hata popup'i) uretiyordu.
      //@ts-ignore
      if (scheduledMs(args.data) === this.dragStartScheduledTime) {
        return
      }

      if (!workOrderStatusPolicy.canEditPlanFields(args.data.StatusId)) {
        args.cancel = true;
        if(localStorage.getItem("vue-lang") === "tr-TR"){
          swal.error("Error","Planlandı ve Atama Yapıldı statüsü harici düzenleme yapılamaz.")
        }else{
          swal.error("Error","No edits can be made except for the Planned and Assigned status.")
        }
        return
      }

      // Syncfusion dragStop'un dondurdugu promise'i beklemiyor: birakmayi iptal edip etmeyecegini
      // ilk await'e kadar set edilen args.cancel'dan ogreniyor. Freeze onayi ise asenkron. Bu
      // yuzden yuklu listeden "freeze'e denk gelmiyor" diyemedigimiz her durumda birakma hemen
      // iptal edilir (etkinlik eski yerine doner); kayit onaydan sonra yapilir ve takvim yeniden
      // yuklenir. Vazgecilirse hicbir sey kaydedilmez.
      const plan = args.data
      const planWindow = this.plannedWindow(plan)
      const loadedHits = this.loadedFreezesCovering(planWindow.start, planWindow.end)
      if (loadedHits && loadedHits.length === 0) {
        await this.saveDraggedPlan(plan)
        return
      }

      args.cancel = true
      // Uyari kaydin kendisinden onemli degil: sunucuya sorulamazsa tasima engellenmez.
      const freezes = loadedHits
        ? loadedHits.map((freeze: any) => freeze.view)
        : (await this.requestFreezes(planWindow.start, planWindow.end)) || []
      if (!(await confirmFreezes(this, freezes))) {
        return
      }
      if (await this.saveDraggedPlan(plan)) {
        this.getData()
      }
    },
    // Birakilan yerdeki calisma penceresi. Syncfusion suruklerken sureyi korur; ExpectedEndTime
    // = ScheduledTime + Duration (dakika). Sifir sureli is de bir an olarak denetlensin diye en
    // az bir dakika alinir.
    plannedWindow(plan: any) {
      const start = new Date(plan.ScheduledTime)
      const endMs = plan.ExpectedEndTime ? new Date(plan.ExpectedEndTime).getTime() : NaN
      const end = new Date(Math.max(isNaN(endMs) ? 0 : endMs, start.getTime() + MINUTE_MS))
      return { start, end }
    },
    // Pencere yuklu araligin icindeyse ona denk gelen freeze'ler (bos dizi = denk gelen yok);
    // degilse null: liste bu pencere icin eksik olabilir, sunucuya sorulmali.
    loadedFreezesCovering(start: Date, end: Date) {
      const range = this.freezeRange
      if (!range || start.getTime() < range.start.getTime() || end.getTime() > range.end.getTime()) {
        return null
      }
      return this.freezes.filter((freeze: any) => overlaps(freeze, start.getTime(), end.getTime()))
    },
    async saveDraggedPlan(plan: any) {
      //@ts-ignore
      let response = (await api.maintenancePlanGetById(plan.Id)).body
      let updateReq = {
        Id: plan.Id,
        ContractId: response.ContractId,
        Duration: response.Duration,
        MaintenanceTypeId: response.OrderType ? response.OrderType.Id : null,
        Note: response.Note,
        StartDate: plan.ScheduledTime.toISOString(),
        VendorId: response.VendorId,
        VendorNotificationRemainingDay: response.VendorNotificationRemainingDay,
      }

      let updateResponse = (await api.updateMaintenancePlan(updateReq)).body
      if (updateResponse.IsSuccess) {
        if(localStorage.getItem("vue-lang") === "tr-TR"){
          swal.success('Kayıt Güncellendi')
        }else{
          swal.success('Updated')
        }
      }
      return !!updateResponse.IsSuccess
    },
    onActionBegin: function (args: any) {
      if (args.requestType === 'toolbarItemRendering') {
        let exportItemExcel = {
          align: 'Left',
          showTextOn: 'Both',
          text: localStorage.getItem("vue-lang") === "tr-TR" ? 'Excel Dışa Aktar' : 'Excel Export',
          cssClass: 'e-excel-export',
          click: this.onExportClick.bind(this),
        }
        args.items.push(exportItemExcel)
        let exportItemPrint = {
          align: 'Left',
          showTextOn: 'Both',
          text: localStorage.getItem("vue-lang") === "tr-TR" ? 'Yazdır' : 'Print',
          cssClass: 'e-print',
          click: this.onPrintIconClick.bind(this),
        }
        args.items.push(exportItemPrint);

        let addMaintenance = {
          align: 'Left',
          showTextOn: 'Both',
          text:    ' <i class="fa fa-plus"></i>' + 
            (localStorage.getItem("vue-lang") === "tr-TR" ? 'Ekle' : 'Add'), 
          cssClass: 'add-text', 
          click: this.onAddMaintenanceClick.bind(this),
        };

        args.items.push(addMaintenance);

        const style = document.createElement("style");
        style.textContent = `
          .add-text {
            font-weight: bold;
            display: flex;
            align-items: center;
          }
          .add-text i {
            margin-right: 5px;
          }
        `;
      document.head.appendChild(style);
      }
    },
    onAddMaintenanceClick : function () {
      this.handleAddMaintenanceClick();
    },
    async handleAddMaintenanceClick() {
      //@ts-ignore
      this.createStartDate = null
      //@ts-ignore
      this.deleteBtnShow = false;
      //@ts-ignore
      this.selectedId = 0
      //@ts-ignore
      this.isDialogActive = true
      //@ts-ignore
      await this.$nextTick()
      //@ts-ignore
      ;(<MaintenancePlanDialog>this.$refs.maintenancePlanDialog).showDialog()
    },
    onExportClick: function () {
      // //@ts-ignore
      // let scheduleObj = this.$refs.ScheduleObj
      // let exportValues = {
      //   fields: ['Id', 'FullName', 'ScheduledTime', 'ExpectedEndTime', 'DeviceName']
      // };
      // //@ts-ignore
      // scheduleObj.exportToExcel(exportValues)
      
      const dateMoment = new Date();
      let excelWorkbook = new ExcelJS.Workbook();
      excelWorkbook.creator = 'CFM';
      excelWorkbook.created = dateMoment;
      excelWorkbook.calcProperties.fullCalcOnLoad = true;
      excelWorkbook.views = [
        {
          x: 0,
          y: 0,
          width: 10000,
          height: 20000,
          firstSheet: 0,
          activeTab: 1,
          visibility: 'visible',
        },
      ];

      const reportColumns = [
        { key: "Id", header: "İş Gurubu", width: 20 },
        { key: "FullName", header: "Full Name", width: 20 },
        { key: "ScheduledTime", header: "Başlangıç Tarihi", width: 20, style: { numFmt: 'dd/mm/yyyy HH:mm' } },
        { key: "ExpectedEndTime", header: "Bitiş Tarihi", width: 20, style: { numFmt: 'dd/mm/yyyy HH:mm' } },
        { key: "DeviceName", header: "Kapasite Ekipmanı", width: 20 },
      ]

      const reportRows = this.eventSettings.dataSource.map(row => {
        return {
          Id: row.Id,
          FullName: row.FullName,
          ScheduledTime: row.ScheduledTime ? dateFormat.viewDateTimeFormatTZ(row.ScheduledTime) : null,
          ExpectedEndTime: row.ExpectedEndTime ? dateFormat.viewDateTimeFormatTZ(row.ExpectedEndTime) : null,
          DeviceName: row.DeviceName,
        };
      });

      let context = [
        {
          sheetName: "Schedule",
          sheetData: reportRows,
          columnName: reportColumns
        }
      ];

      context.forEach((contextItem) => {
        // Add Work Sheet
        let sheet = excelWorkbook.addWorksheet(contextItem.sheetName, {});
        sheet.columns = contextItem.columnName;

        // Add Data 
        contextItem.sheetData.forEach((row) => {
          sheet.addRow(row);
        });

        // Add Header Style
        sheet.eachRow((sheetRow, sheetRowNumber) => {
          if (sheetRowNumber == 1) {
            sheet.autoFilter = `${sheet.getColumn(1).letter + "1:" + sheet.getColumn(sheet.columns.length).letter + "1"}`;
            sheetRow.font = { bold: true, size: 12 };
            sheetRow.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '0042a5f5' } };
          }
          else if (sheetRow.getCell(10).value === "No") {
            sheetRow.font = { color: { argb: '00ff0000'}, bold: true, size: 10 };
          }
          else {
            sheetRow.font = { bold: false, size: 10 };
          }

          sheetRow.commit();
        });
      });

      excelWorkbook.xlsx.writeBuffer().then((buffer) => {
        const uint8Array = new Uint8Array(buffer);
        this.saveByteArray(`Schedule.xlsx`, uint8Array);
      });
    },
    saveByteArray(reportName: string, byte: Uint8Array) {
      const blob = new Blob([byte], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

      if (navigator.appVersion.toString().indexOf('.NET') > 0) window.navigator.msSaveBlob(blob, reportName);
      else {
        const link = document.createElementNS('http://www.w3.org/1999/xhtml', 'a') as HTMLAnchorElement;
        link.href = URL.createObjectURL(blob);
        link.download = reportName;
        link.click();
      }
    },
    onPrintIconClick: function () {
      //@ts-ignore
      let scheduleObj = this.$refs.ScheduleObj
      //@ts-ignore
      scheduleObj.print()
    },
  },
}
